import React, { useMemo } from "react";
import "./styles.css";
import Text from "../typography/text";
import { Tooltip } from "antd";
import { colors } from "../../theme/colors";

const STATUS_STLYES = {
  pending: {
    borderColor: "var(--primaryColorDark)",
    color: "primaryColor",
  },
  submitted: {
    backgroundColor: "var(--primaryColor)",
    color: "white",
  },
  infoRequired: {
    backgroundColor: "var(--warningColor)",
    color: "white",
  },
  notCovered: {
    backgroundColor: "var(--failureColor)",
    color: "white",
  },
  covered: {
    backgroundColor: "var(--successColor)",
    color: "white",
  },
};

const STATUS_KEYS = {
  pending: "pending",
  submitted: "submitted",
  covered: "covered",
  infoRequired: "infoRequired",
  notCovered: "notCovered",
};

const normalizeInsuranceStatus = (value) => {
  if (!value) return STATUS_KEYS.pending;
  const raw = String(value).trim().toLowerCase();
  if (!raw) return STATUS_KEYS.pending;
  const compact = raw.replace(/[^a-z]/g, "");
  switch (compact) {
    case "pending":
      return STATUS_KEYS.pending;
    case "submitted":
      return STATUS_KEYS.submitted;
    case "covered":
      return STATUS_KEYS.covered;
    case "inforequired":
      return STATUS_KEYS.infoRequired;
    case "notcovered":
      return STATUS_KEYS.notCovered;
    default:
      return STATUS_KEYS.pending;
  }
};

const getProductName = (product) =>
  product?.productName ||
  product?.ProductGroupName ||
  product?.ManufacturerName ||
  product?.ProductName ||
  (product?.ID ? `Product ${product.ID}` : "Product");

const StatusByProduct = ({ status, productList, products }) => {
  const productsByStatus = useMemo(() => {
    const sourceList = Array.isArray(products)
      ? products
      : Array.isArray(productList)
      ? productList
      : [];
    const map = new Map();
    sourceList.forEach((product) => {
      const statusKey = normalizeInsuranceStatus(
        product?.status ?? product?.InsuranceStatus ?? product?.insuranceStatus
      );
      const name = getProductName(product);
      if (!map.has(statusKey)) {
        map.set(statusKey, []);
      }
      map.get(statusKey).push(name);
    });
    return map;
  }, [products, productList]);

  return (
    <div className="status-product-wrapper">
      {status?.map((item, index) => {
        const styles = STATUS_STLYES[item?.status] || {};
        const productNames = productsByStatus.get(item?.status) || [];
        return item?.count > 0 ? (
          <div key={index} className="status-product-parent-container">
            <Text variant="smallText">{item?.statusText}</Text>
            <Tooltip
              placement="top"
              color={colors["blueBackground"]}
              overlayInnerStyle={{
                maxHeight: 200,
                overflowY: "auto",
              }}
              title={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: 2,
                    gap: 4,
                  }}
                >
                  {productNames.length ? (
                    productNames.map((name, idx) => (
                      <Text key={`${name}-${idx}`}>{name}</Text>
                    ))
                  ) : (
                    <Text>No products</Text>
                  )}
                </div>
              }
            >
              <div
                className="status-product-count-container"
                style={{
                  border: `1px solid ${styles.borderColor}`,
                  backgroundColor: styles.backgroundColor,
                  cursor: "pointer",
                }}
              >
                <Text variant="smallText" color={styles.color}>
                  {item?.count}
                </Text>
              </div>
            </Tooltip>
          </div>
        ) : null;
      })}
    </div>
  );
};

export default StatusByProduct;
